<template lang="pug">
  transition(name="fade")
    .fw-modal-overlay(ref="overlay", v-if="isOpen", @click="closeModal")
      .fw-modal-content
        .fw-modal-close(@click="close", @keydown="close")
          font-awesome-icon(:icon="['fas', 'times']")
        slot
</template>

<script>

export default {
  name: 'ModalOverlay',
  components: {
  },
  props: {
    open: Boolean
  },
  data () {
    return {
      isOpen: false
    }
  },
  mounted () {
    this.isOpen = this.open

    document.addEventListener('keydown', this.close)
  },
  methods: {
    closeModal (e) {
      if (e.target === this.$refs.overlay) this.close(e)
    },
    close (e) {
      //console.log(e)

      // escape key check
      if (e.type === 'keydown' && e.key !== 'Escape') return

      //this.isOpen = false
      this.$emit('close')
    }
  },
  watch: {
    open (val) {
      this.isOpen = val

      if (this.isOpen) {
        document.body.classList.add('modal-open')
      } else {
        document.body.classList.remove('modal-open')
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.close)
  }
}
</script>

<style scoped lang="stylus">
  body.modal-open
    overflow hidden
  .fw-modal-overlay
    align-items center
    background-color rgba(0,0,0,.5)
    display flex
    padding $spacing-3
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    z-index 10000
    .fw-modal-content
      background-color #fff
      border-radius $border-radius
      position relative
      margin 0 auto
      max-width 800px

      .fw-modal-close
        background-color #fff
        border-radius 100%
        color $text-light
        cursor pointer
        padding $spacing
        position absolute
        top 0
        right 0
        //text-align center
        //transform translate(30%, -30%)
        //height 37px
        //width 37px
        &:hover
          color $text-default


</style>
